(function() {
  'use strict';

  let stickySidebarInstance = null;
  let resizeTimeout = null;
  let headerObserver = null;

  function getHeaderHeight() {
    const fixHeader = document.querySelector('.fix-header');
    return fixHeader ? (fixHeader.offsetHeight || fixHeader.clientHeight || 0) : 20;
  }

  function handleResize() {
    if (!stickySidebarInstance) return;

    try {
      requestAnimationFrame(function() {
        if (stickySidebarInstance && typeof stickySidebarInstance.updateSticky === 'function') {
          stickySidebarInstance.updateSticky({ type: 'resize' });
        }
      });
    } catch (error) {
      return;
    }
  }

  function debouncedResize() {
    if (resizeTimeout) clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 150);
  }

  function setupResizeListeners() {
    if (!stickySidebarInstance) return;

    window.addEventListener('resize', debouncedResize, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const fixHeader = document.querySelector('.fix-header');
      if (fixHeader) {
        headerObserver = new ResizeObserver(debouncedResize);
        headerObserver.observe(fixHeader);
      }
    }
  }

  function initSticky() {
    if (typeof StickySidebar === 'undefined') {
      setTimeout(initSticky, 100);
      return;
    }

    const sidebarElement = document.querySelector('.news-event-list-sidebar');
    const containerElement = document.querySelector('.news-event-list-container.has-sidebar');
    
    if (!sidebarElement || !containerElement) return;

    try {
      stickySidebarInstance = new StickySidebar('.news-event-list-sidebar', {
        topSpacing: getHeaderHeight,
        bottomSpacing: 20,
        containerSelector: '.news-event-list-container.has-sidebar',
        innerWrapperSelector: '.sidebar-news'
      });
      setupResizeListeners();
    } catch (error) {
      return;
    }
  }

  function waitForLibrary() {
    if (typeof StickySidebar !== 'undefined') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSticky);
      } else {
        initSticky();
      }
    } else {
      setTimeout(waitForLibrary, 50);
    }
  }

  waitForLibrary();
})();